export default {
  clearAll: () => {},
}
